/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SchemaInputs */

const en_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

const ar_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المخطط`)
};

const bn_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কিমা`)
};

const de_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

const es_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquema`)
};

const fr_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schéma`)
};

const pt_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquema`)
};

const zh_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`架构`)
};

const tr_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

const ru_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схема`)
};

const pl_svchip_schema = /** @type {(inputs: Svchip_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schemat`)
};

/**
* | output |
* | --- |
* | "Schema" |
*
* @param {Svchip_SchemaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_schema = /** @type {((inputs?: Svchip_SchemaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SchemaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_schema(inputs)
	if (locale === "bn") return bn_svchip_schema(inputs)
	if (locale === "de") return de_svchip_schema(inputs)
	if (locale === "es") return es_svchip_schema(inputs)
	if (locale === "fr") return fr_svchip_schema(inputs)
	if (locale === "pt") return pt_svchip_schema(inputs)
	if (locale === "zh") return zh_svchip_schema(inputs)
	if (locale === "tr") return tr_svchip_schema(inputs)
	if (locale === "ru") return ru_svchip_schema(inputs)
	if (locale === "pl") return pl_svchip_schema(inputs)
	return en_svchip_schema(inputs)
});